import IconCheck from '@/shared/icons/NewDesign/IconCheck'
import IconClock from '@/shared/icons/NewDesign/IconClock'
import IconRing from '@/shared/icons/NewDesign/IconRing'
import type { PillState } from '../fidelityJourney'
import { StyledPill } from '../styled-components'

const PILL_ICONS = { ok: IconCheck, wait: IconClock, todo: IconRing }

interface StatusPillProps {
  label: string
  state: PillState
}

const StatusPill = ({ label, state }: StatusPillProps) => {
  const Icon = PILL_ICONS[state]

  return (
    <StyledPill $state={state}>
      <Icon size={12} />
      {label}
    </StyledPill>
  )
}

export default StatusPill
